
import { NgxLoggerLevel } from 'ngx-logger';

export const environment = {
  production: true,
  defaultauth: 'fackbackend',
  firebaseConfig: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: '',
  },

  // api:'http://localhost:3000/api/',
     api:'https://multi.ternium.scvplatform.com/api/',


  
  


  idleTimeInMinutes: 5,
  logLevel: NgxLoggerLevel.OFF,
  serverLogLevel: NgxLoggerLevel.ERROR,
  

};
